import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import { useEffect } from 'react';
import { type AppEntry } from '@/app/routes-types';
import { BusTimesPage } from '@/features/schedules/BusTimesPage';
import { SURFACES } from '@/lib/gql/__generated__/surfaces';
import { guardSurface } from '@/lib/platform/surfaces';

export const entry: AppEntry = { default: '/', byRole: {} };

function NotFoundPage() {
  useEffect(() => {
    const root = document.getElementById('root');
    root?.setAttribute('data-app-notfound', '1');
    return () => root?.removeAttribute('data-app-notfound');
  }, []);
  return (
    <main className="grid min-h-screen place-items-center bg-background p-6 text-center">
      <div>
        <p className="text-sm font-semibold uppercase tracking-[0.2em] text-muted-foreground">404</p>
        <h1 className="mt-2 text-3xl font-semibold">This stop does not exist.</h1>
      </div>
    </main>
  );
}

const rootRoute = createRootRoute({ notFoundComponent: NotFoundPage });
const busTimesRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/',
  beforeLoad: () => guardSurface(entry, SURFACES['bus-times']),
  staticData: { title: 'Seattle Bus Times', page: SURFACES['bus-times'], standalone: false, isPublic: true },
  component: BusTimesPage,
});
const routeTree = rootRoute.addChildren([busTimesRoute]);
export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
